import { BaseApiService } from '~/services/base-api.service';
import { IApiService } from '~/services/interfaces/IApiService';
import { getCXEnvironment } from '~/utils/cx-utils/cx-environment.utils';
import { CXEnvironments } from '~/types/cx-types/cx-environment.types';
import { getStagingApiBaseUrl } from '~/utils/cx-utils/cx-api.utils';

export class UnauthenticatedApiService
    extends BaseApiService
    implements IApiService
{
    protected getBaseUrl() {
        const env = getCXEnvironment();

        if (!env) {
            return '/';
        }

        switch (env.environment) {
            case CXEnvironments.Production:
                return 'https://api.honeybook.com';
            case CXEnvironments.Development:
                return '/';
            case CXEnvironments.Staging:
                return getStagingApiBaseUrl();
            default:
                return '/';
        }
    }

    getHeaders(): Record<string, string> {
        const { configStore } = this.globalContext;
        const {
            config: { hb_api_headers, api_version }
        } = configStore;

        if (hb_api_headers && api_version) {
            return {
                [hb_api_headers?.api_client_version || '']: api_version + ''
            };
        }

        return {};
    }
}
